<template lang="pug">
  div.form-group
    label( :for="name" )
      i.fas.fa-asterisk.fa-xs.text-danger.mr-1( v-if="validation.hasOwnProperty( 'required' )" )
      | {{ label }}

    small.form-text.text-muted( v-if="hint" )
      | {{ hint }}
    span.invalid-feedback( v-if="validation.hasOwnProperty( 'required' ) && !validation.required && validation.$error" )
      | can't be blank
    list-select(:list="options"
            v-model="value"
            option-value="id"
            option-text="name"
            :name="name"
            :id="id"
            :placeholder="placeholder"
            @input="onInput")
</template>

<script>
  import { ListSelect } from 'vue-search-select/lib'
  export default {
    name: "formSearchSelect",
    components: {
      ListSelect
    },

    props: {
      value: {
        type: [ Number, String ],
        required: false,
        default: null
      },
      validation: Object,
      id:String,
      name: String,
      placeholder: String,
      label: String,
      hint: String,      
      optid: String,
      optval: String,
      options: {
        type: Array,
        required: false,
        default: null
      },
      trim: {
        type: Boolean,
        default: true
      }
    },

    methods: {
      onInput( event ) {
        this.$emit( 'input', event );
      }
    }
  }
</script>

<style scoped>

</style>
